export default __webpack_public_path__ + "static/media/Iceburg.12049c52.png";